import { render, staticRenderFns } from "./clinic-selector-dropdown.vue?vue&type=template&id=f5afdc22&scoped=true"
import script from "./clinic-selector-dropdown.vue?vue&type=script&lang=js"
export * from "./clinic-selector-dropdown.vue?vue&type=script&lang=js"
import style0 from "./clinic-selector-dropdown.vue?vue&type=style&index=0&id=f5afdc22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5afdc22",
  null
  
)

export default component.exports